import { gql } from '@apollo/client';

export const MUTATION_CREATE_NOTIFICATION = gql`
    mutation CreateNotification($data: CreateNotificationInput!) {
        createNotification(data: $data) {
            id
            name
            recordType {
                id
                name
                displayName
            }
            event {
                id
                name
                displayName
                recordTypeId
            }
            condition {
                fieldId
                fieldName
                fieldType
                operator
                value
            }
            priority
            frequency
            channels
            enabled
            createdAt
            updatedAt
        }
    }
`;

export const MUTATION_UPDATE_NOTIFICATION = gql`
    mutation UpdateNotification($id: String!, $data: UpdateNotificationInput!) {
        updateNotification(id: $id, data: $data) {
            id
            name
            recordType {
                id
                name
                displayName
            }
            event {
                id
                name
                displayName
                recordTypeId
            }
            condition {
                fieldId
                fieldName
                fieldType
                operator
                value
            }
            priority
            frequency
            channels
            enabled
            updatedAt
        }
    }
`;

export const MUTATION_DELETE_NOTIFICATION = gql`
    mutation DeleteNotification($id: String!) {
        deleteNotification(id: $id) {
            id
            deleted
            deletedAt
            updatedAt
        }
    }
`;

export const MUTATION_RESTORE_NOTIFICATION = gql`
    mutation RestoreNotification($id: String!) {
        restoreNotification(id: $id) {
            id
            name
            recordType {
                id
                name
                displayName
            }
            event {
                id
                name
                displayName
                recordTypeId
            }
            deleted
            deletedAt
            enabled
            updatedAt
        }
    }
`;

export const MUTATION_TOGGLE_NOTIFICATION = gql`
    mutation ToggleNotification($id: String!, $enabled: Boolean!) {
        toggleNotification(id: $id, enabled: $enabled) {
            id
            enabled
            updatedAt
        }
    }
`;

export const MUTATION_BULK_TOGGLE_NOTIFICATIONS = gql`
    mutation BulkToggleNotifications($enabled: Boolean!) {
        bulkToggleNotifications(enabled: $enabled) {
            id
            enabled
            updatedAt
        }
    }
`;
